export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// /home/admin/web/newbirddesign.ecdevstage.com/public_html/web/app/themes/bbe_theme/node_modules/swiper/esm/components/core/translate/maxTranslate.js
// module id = 40
// module chunks = 0